window.ROUNDUP_VARIANT_ID = 33018448969814;
window.ROUNDUP_DEFAULT_CHECKED =  "True" === "True";
if (typeof jQuery === 'undefined') {
    document.write('<script src="https://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js"></script>');
    document.write('<script type="text/javascript">jQuery.noConflict();</script>');
}

jQuery.fn.visible = function() {
    return this.css('visibility', 'visible').hide().fadeIn('slow');
};

jQuery.fn.invisible = function() {
    return this.css('visibility', 'hidden');
};



jQuery(document).ready(function () {

    /////////////////////////
    // Variable and local function definition
    /////////////////////////

    var vesey_charity_embed_div = jQuery(".round_up_container");
    if (vesey_charity_embed_div.length == 0) return;

    var css_url = '{{ "round_up.css" | asset_url }}';
    var app_derived_currency = "$";
    // Loaded and updated from App
    var round_up_variant_id = 33018448969814;
    var round_up_popover_description = "Donate a small portion of your purchase to support the <a href='https://www.lastprisonerproject.org/' target='_blank'>Last Prisoner Project</a>.";

    var global_resultPrice = 0

    var changeRoundUpText = function(popover_description) {
        // Find and replace text of roundup popover
        jQuery('#vesey_charity_embed_tooltip').html('<span class="vesey_charity_embed_tooltiptext">' + popover_description + '</span>');

        // Add the popover text and formatting
        jQuery('#vesey_charity_embed_tooltip').addClass('vesey_charity_embed_question_mark');
        jQuery('.charity_embed_round_difference').html(app_derived_currency+"1.00");
        // Make the charity roundup element visible
        jQuery(vesey_charity_embed_div).visible();
    };


    var insertDynamicCSS = function() {
        if(jQuery(vesey_charity_embed_div).length>0){

            jQuery(vesey_charity_embed_div).invisible();

            if (document.createStyleSheet){
                document.createStyleSheet('' + css_url + '');
                return true;
            }
            else {
                jQuery("head").append(jQuery('<link rel="stylesheet" href="' + css_url + '" type="text/css" media="screen" />'));
                return true;
            }

            return false;
        }
        else {
            return false;
        }
    };

    /////////////////////////
    // Vesey Roundup Logic
    /////////////////////////

    // Insert CSS asset to cart header.
    var css_inserted = false;
    css_inserted = insertDynamicCSS();

    // Make sure we have a roundup product ID
    if (round_up_variant_id == false) {
        return;
    }

    // Verify CSS was inserted.
    if (css_inserted == false) {
        // The CSS was not inserted, cancel script execution.
        return;
    }

    // Change popover description and show main checkbox element
    changeRoundUpText(round_up_popover_description);
    
    if (window.roundupInitializer) {
        window.roundupInitializer();
    }
});